module.exports = __webpack_public_path__ + "static/media/ic_download.3ae513ca.svg";